<template>
  <div class="card card-modern pt-3" style="border: none; box-shadow: none;">
    <div class="modern-header" style="display: flex; align-items: center; gap: 15px; margin-bottom: 20px;">
      <div class="header-icon" style="background: #fff7ed; color: #ff9800; width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
        <i class="material-icons" style="font-size: 24px; margin: 0;">public</i>
      </div>
      <h4 class="card-title" style="margin: 0; font-size: 1.5rem; color: #1e293b;">Selecione um estado</h4>
    </div>
    <div class="card-body">
      <div style="display: flex; height: 300px" v-if="buscando">
        <div class="lds-spinner" style="margin: auto">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div
        v-show="!buscando"
        id="container"
        style="width: 100%; min-height: 500px; height: calc(100vh - 260px)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buscando: false,
      estado: [],
      data: [
        ["br-sp", 0],
        ["br-ma", 1],
        ["br-pa", 2],
        ["br-sc", 3],
        ["br-ba", 4],
        ["br-ap", 5],
        ["br-ms", 6],
        ["br-mg", 7],
        ["br-go", 8],
        ["br-rs", 9],
        ["br-to", 10],
        ["br-pi", 11],
        ["br-al", 12],
        ["br-pb", 13],
        ["br-ce", 14],
        ["br-se", 15],
        ["br-rr", 16],
        ["br-pe", 17],
        ["br-pr", 18],
        ["br-es", 19],
        ["br-rj", 20],
        ["br-rn", 21],
        ["br-am", 22],
        ["br-mt", 23],
        ["br-df", 24],
        ["br-ac", 25],
        ["br-ro", 26],
      ],
    };
  },
  methods: {
    quantidadeGeracaoDistribuida() {
      this.buscando = true;

      callAPI(
        '/estado/quantidade-geracao-distribuida-por-estado',
        'GET',
        null,
        (estados) => {
          this.data = [];
          for (const key in estados) {
            var estado = estados[key];
            this.data.push(["br-" + estado.uf.toLowerCase(), estado.teste]);
          }
          this.estados = estados;
          this.buscando = false;
          this.init();
        }
      );
    },
    selecionar(e) {
      var uf = e.point.options["hc-key"];
      for (const key in this.estados) {
        var estado = this.estados[key];
        if ("br-" + estado.uf.toLowerCase() == uf) {
          this.$emit("selecionar", estado);
          return;
        }
      }
    },
    init() {
      Highcharts.mapChart("container", {
        chart: {
          map: "countries/br/br-all",
        },

        title: {
          text: "",
        },

        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        colorAxis: {
          min: 0,
          minColor: "#fff7ed",
          maxColor: "#ea580c"
        },

        series: [
          {
            data: this.data,
            name: "Quantidade de UCs com GD",
            states: {
              hover: {
                color: "#1e293b",
              },
              select: {
                color: "#1e293b",
              }
            },
            events: {
              click: this.selecionar,
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}",
            },
          },
        ],
      });
    },
  },
  mounted() {
    this.quantidadeGeracaoDistribuida();
  },
};
</script>